
import RoleSet from './index.vue'

RoleSet.install = function (Vue) {
  Vue.component(RoleSet.name, RoleSet)
}

export default RoleSet